/**
 * @description Simple hook that retrieves the known mapping names (since they must be unique)
 */

import React from 'react';

import { ToastContext } from '@seccon/core/contexts/toast';
import decodeJson from '@seccon/shared/utils/decodeJson';

const useMappingNames = () => {
  const [nameList, setNameList] = React.useState(null);
  const toastApi = React.useContext(ToastContext);

  /**
   * Handles successful retrieval of mapping name
   * @param response {object} - API response
   */
  function handleSuccess (response) {
    // Iterate through the entries in the response list and retrieve any non-null/non-empty name
    const results = response.reduce((list, entry) => {
      if (entry.name) {
        // Unique check is case insensitive, so add the lower case version of the name to the list
        list.push(entry.name.trim().toLowerCase());
      }

      return list;
    }, []);

    setNameList(results);
  }

  /**
   * Handles failed retrieval of the mapping names
   */
  function handleFailure () {
    toastApi.error('List of existing personnel maps could not be retrieved. Reload the page and try again.');
  }

  React.useEffect(() => {
    // If the name list has already been retrieved, do nothing
    if (nameList !== null) {
      return;
    }

    fetch('/mappings')
      .then(decodeJson)
      .then(handleSuccess)
      .catch(handleFailure)
  }, []);

  return nameList;
};

export default useMappingNames;
